import { connect } from 'react-redux'
import Profile from './Profile'
import * as actions from '../../../layouts/LoggedIn/actions'
import { recieveLoginstatus } from '../../../routes/Login/actions'
import { upgradeUser } from '../../../routes/Settings/actions'

const mapStateToProps = (state, ownProps) => {
  return {
    userid: state.loginLayout.profile.userid,
    name: state.loginLayout.profile.name,
    role: state.loginLayout.profile.role,
    email: state.loginLayout.profile.email,
    accountType: state.loginLayout.profile.accountType,
    logoutSuccess: state.loginLayout.logoutSuccess,
    expires_in: state.loginLayout.user.expires_in,
    failed_payment_count: state.loginLayout.user.failed_payment_count,
    failed_payment_date: state.loginLayout.user.failed_payment_date,
    card_update_date: state.loginLayout.user.card_update_date,
    view: state.loginLayout.view,
    ...ownProps
  }
}

const mapDispatchToProps = (dispatch) => (
  {
    logoutUser: (token) => dispatch(actions.logoutUser(token)),
    recieveLoginstatus: (bool, user) => dispatch(recieveLoginstatus(bool, user)),
    shouldRedirectUser: (bool) => dispatch(actions.shouldRedirectUser(bool)),
    newSeminarUpgradeModal: (bool) => dispatch(actions.newSeminarUpgradeModal(bool)),
    upgradeUser: (token, userid, plan) => dispatch(upgradeUser(token, userid, plan)),
  }
)

const ProfileContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile)

export default ProfileContainer


// WEBPACK FOOTER //
// src/components/Profile/NavBarProfile/ProfileContainer.js